module.exports = __webpack_public_path__ + "img/1-min.3f8e045e.jpg";